<template>
  <el-group-title title="分包机械设备清单" class="ccui-group-wrapper">
    <template slot="groupTitle">
      <el-form
        :model="form"
        label-width="100px"
        class="ccui-form"
        style="overflow:visible;"
      >
        <div class="extend-btn">
          <el-button plain type="single-number" @click="addTable">
            新增
          </el-button>
        </div>
        <el-table
          :data="tableData"
          class="ccui-form-child-table"
          border
          max-height="99999"
        >
          <el-table-column
            :show-overflow-tooltip="true"
            label="序号"
            type="index"
            align="center"
            fixed
          />
          <el-table-column
            :show-overflow-tooltip="true"
            prop="machineCode"
            label="机械编码"
          >
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.machineCode"
                placeholder="请输入机械编码"
                clearable
                maxlength="50"
              />
            </template>
          </el-table-column>

          <el-table-column
            :show-overflow-tooltip="true"
            prop="machineName"
            label="机械名称"
          >
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.machineName"
                placeholder="请输入机械名称"
                clearable
                maxlength="100"
              />
            </template>
          </el-table-column>

          <el-table-column
            :show-overflow-tooltip="true"
            prop="specifications"
            label="规格型号"
          >
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.specifications"
                placeholder="请输入规格型号"
                clearable
                maxlength="50"
              />
            </template>
          </el-table-column>

          <el-table-column
            :show-overflow-tooltip="true"
            prop="placeOfOrigin"
            label="产地"
          >
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.placeOfOrigin"
                placeholder="请输入产地"
                clearable
                maxlength="100"
              />
            </template>
          </el-table-column>

          <el-table-column
            :show-overflow-tooltip="true"
            prop="productionDate"
            label="制造时间"
            min-width="100%"
          >
            <template slot-scope="scope">
              <el-date-picker
                type="date"
                placeholder="请选择制造时间"
                v-model="scope.row.productionDate"
                style="width:100%"
                clearable
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </template>
          </el-table-column>

          <el-table-column
            :show-overflow-tooltip="true"
            prop="rateOfWork"
            label="能力/功率"
          >
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.rateOfWork"
                placeholder="请输入能力/功率"
                clearable
                maxlength="20"
              />
            </template>
          </el-table-column>

          <el-table-column
            :show-overflow-tooltip="true"
            prop="dateOfEntry"
            label="进场日期"
            min-width="100%"
          >
            <template slot-scope="scope">
              <el-date-picker
                type="date"
                placeholder="请选择进场日期"
                v-model="scope.row.dateOfEntry"
                style="width:100%"
                clearable
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </template>
          </el-table-column>

          <el-table-column
            :show-overflow-tooltip="true"
            prop="remark"
            label="备注"
          >
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.remark"
                placeholder="请输入备注"
                clearable
                maxlength="500"
              />
            </template>
          </el-table-column>

          <el-table-column
            :show-overflow-tooltip="true"
            prop="scaleNum"
            label="操作"
            align="center"
            width="100%"
          >
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="text"
                @click="delTable(scope.$index, scope.row)"
              >
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
    </template>
  </el-group-title>
</template>

<script>
export default {
  name: "materialsManagementInventory",
  props: {
    responsibility: {
      type: String,
      default: ""
    },
    taxRate: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      tableData: [{ id: "1" }],
      form: {}
    };
  },
  methods: {
    // 新增
    addTable() {
      this.tableData.push({
        id: this.tableData.length + 1
      });
    },
    // 删除
    delTable(index, row) {
      this.tableData.splice(index, 1);
    }
  }
};
</script>
